import { ErrorMessage, Formik, Form } from 'formik';
import React, { useRef } from 'react'
import { Button, Modal } from 'react-bootstrap';
import TextField from '../textField/TextField';
import * as Yup from "yup";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { useDispatch } from 'react-redux';
import { handleLoader } from '../../redux/reducers/layout';
import makeRequest from '../../utils/makeRequest';
import * as urls from "../../utils/URLConst";
import toastNotify from '../../utils/ToastNotify';
import { useNavigate } from 'react-router-dom';

const InquiryTicketMdl = ({ isOpen, handleIsTicketInquiryMdl, itemCodeData, setItemCodeData, inquiryData }) => {

    const dispatch = useDispatch();
    const editorRef = useRef();
    const navigate = useNavigate();

    const editorConfiguration = {
        toolbar: {
            items: [
                "heading",
                "|",
                "bold",
                "italic",
                "|",
                "bulletedList",
                "numberedList",
                "|",
                "insertTable",
                "|",
                "undo",
                "redo",
            ],
        },
    };

    async function generateInquiryTicket(val) {
        try {
            dispatch(handleLoader(true));
            const payload = {
                DEPARTMENT_CD: "1",
                PRODUCT_CD: itemCodeData,
                SUBJECT: val.subject,
                DESCRIPTION: val.discription,
                FILE_B64: "",
                FILE_SIZE: "",
                PRIORITY: "N",
                CLASSIFICATION: "Q",
            };
            const config = {};
            await makeRequest("POST", urls.setTicket, payload, config).then(
                (result) => {
                    if (result.STATUS === "0") {
                        toastNotify(result.MESSAGE, "success");
                        setItemCodeData(null);
                        handleIsTicketInquiryMdl();
                        navigate("/product-inquiry");
                    } else {
                        toastNotify(result.MESSAGE, "error");
                        setItemCodeData(null);
                    }
                }
            );
        } catch (error) {
            // Ignore Case
        } finally {
            dispatch(handleLoader(false));
        }
    }

    return (
        <Modal
            backdrop="static"
            keyboard={false}
            show={isOpen}
            onHide={handleIsTicketInquiryMdl}
        >
            <Modal.Header closeButton>
                <Modal.Title>Add Inquiry</Modal.Title>
            </Modal.Header>

            <Formik
                enableReinitialize={true}
                initialValues={{
                    subject: "Inquiry For This " + inquiryData.ITEM_NM,
                    discription: `<p><strong>Dear Soft-tech team,</strong></p><p>I hope this message finds you well. I am writing to inquire about one of your products — ${inquiryData.ITEM_NM}.</p>`,
                }}
                validationSchema={Yup.object({
                    subject: Yup.string().required("Subject is required field"),
                    discription: Yup.string().required("Description is required field"),
                })}
                onSubmit={(values) => {
                    generateInquiryTicket(values);
                }}
            >
                {({ values, handleChange, handleBlur, setFieldValue }) => {
                    return (
                        <Form>
                            <Modal.Body>
                                <div>
                                    <TextField
                                        label="Subject"
                                        name="subject"
                                        id="subject"
                                        required
                                        tabIndex={10}
                                        maxLength={100}
                                        value={values.subject}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                    />
                                    <ErrorMessage name="subject" className='error-msg' component="div" />
                                </div>
                                <div>
                                    <label
                                        htmlFor="discription"
                                        className="form-label"
                                    >
                                        Description
                                        <span className="text-danger h5"> *</span>
                                    </label>
                                    <CKEditor
                                        editor={ClassicEditor}
                                        config={editorConfiguration}
                                        name="discription"
                                        ref={editorRef}
                                        data={values.discription}
                                        onChange={(event, editor) => {
                                            const data = editor?.getData?.();
                                            if (data) {
                                                setFieldValue("discription", data);
                                            }
                                        }}
                                    />
                                    <ErrorMessage name="discription" className='error-msg' component="div" />
                                </div>
                            </Modal.Body>
                            <Modal.Footer className=" py-2">
                                <Button
                                    variant="primary"
                                    type="submit"
                                    className=" btn-sm"
                                >
                                    Submit
                                </Button>
                                <Button
                                    variant="secondary"
                                    type="button"
                                    className="btn-sm"
                                    onClick={handleIsTicketInquiryMdl}
                                >
                                    Cancel
                                </Button>
                            </Modal.Footer>
                        </Form>
                    )
                }}
            </Formik>
        </Modal >
    )
}

export default InquiryTicketMdl